import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { BottomLeftPartIcon, BottomBarPlusText } from '../../styledComponents';
export default function BottomBarLeftSide(props) {
  const { dailyWheelAssets, step, wheelBonus, dailyBonus, linkedAccount, currentTierBonus, cardIconPath } = props;
  return (
    <React.Fragment>
      <div className={`bonusContainer ${step === 2 ? 'WheelBonusAnimation' : 'BonusContainerSmall'}`}>
        <BottomLeftPartIcon src={dailyWheelAssets.DAILY_SPIN_WHEEL_ICON} alt="Small Wheel" />
        <span className="bonusAmount" data-label={wheelBonus}>
          {wheelBonus}
        </span>
        <span className="bonusInfo" data-label="WHEEL BONUS">
          {getText(TEXT_KEY.WHEEL_BONUS)}
        </span>
      </div>
      <BottomBarPlusText>{getText(TEXT_KEY.PLUS_SYMBOL)}</BottomBarPlusText>
      <div className={`bonusContainer ${step === 2 ? 'DailyBonusAnimation' : 'BonusContainerSmall'}`}>
        <BottomLeftPartIcon src={dailyWheelAssets.DAILY_SPIN_CALENDAR_ICON} alt="Calendar" />
        <span className="bonusAmount" data-label={dailyBonus}>
          {dailyBonus}
        </span>
        <span className="bonusInfo" data-label="DAILY BONUS">
          {getText(TEXT_KEY.DAILY_BONUS)}
        </span>
      </div>
      <BottomBarPlusText>{getText(TEXT_KEY.PLUS_SYMBOL)}</BottomBarPlusText>
      <div className={`bonusContainer ${step === 2 ? 'TierBonusAnimation' : 'BonusContainerSmall'}`}>
        <BottomLeftPartIcon src={cardIconPath ? cardIconPath : dailyWheelAssets.DAILY_SPIN_CARDS_ICON} alt="Card" />
        <span className="bonusAmount" data-label={linkedAccount ? `${currentTierBonus}%` : '-'}>
          {linkedAccount ? `${currentTierBonus}%` : '-'}
        </span>
        <span className={linkedAccount ? 'bonusInfo' : 'tierNotLinked'} data-label="TIER BONUS">
          {linkedAccount ? getText(TEXT_KEY.TIER_BONUS) : getText(TEXT_KEY.TIER_BONUS_NOT_LINKED)}
        </span>
      </div>
    </React.Fragment>
  );
}

